<template>
  <div class="cloudHosting">
    <div class="searchwrap">
      <div class="inputwrap">
        <input id="searchinput" @keypress="enterPress" class="searchinput" type="text" name="" v-model="searchText" placeholder="手机号码" @blur="inputBlur" @focus="inputFocus">
        <i @click="onSearchClick" class="inputstart-icon iconfont icon-search" :class="(inputIsFocus && !searchText) || (inputIsFocus || searchText) ? 'lf5' : 'lf90'  "></i>
        <i class="inputend-icon iconfont" :class="searchText ? 'icon-clear' : ''" @click="clearInput"></i>
      </div>
    </div>
    <!-- <div class="filterBtn" @click="showFilter">
      筛选
      <i class="iconfont icon-select"></i>
    </div>
    <div
      class="filterText"
    >{{filterText == "全部,全部,全部" ? "全部" : filterText.replace("全部,",'').replace("全部,",'').replace(",全部",'')}} ({{totalCount}})</div> -->
    <div v-if="isEmpty" class="empty">
      <img src="../../../assets/images/bnodata.png" alt="">
      <div class="desc">暂无数据</div>
    </div>
    <div v-else class="list">
      <van-list :immediate-check="false" :offset="50" v-model="loading" :finished="finished" finished-text @load="onLoad">
        <div class="customer" v-for="(customer, index) in data" :key="index">
          <van-row class="customer-line lh78" @click.native="linkSkip('cloudDetail',{phone: customer.phone},'','')">
            <!-- <van-col class="lh78 text-center" span="3">
              <i class="iconfont icon-customer primary fs22"></i>
            </van-col> -->
            <van-col class="lh78" span="14">
              <div class="customer-info">
                <div class="customer-name title-text">{{customer.phone}}<span :class="customer.cloud=='true'?'theCloud show':'theCloud hide'">云</span></div>
              </div>
            </van-col>
            <van-col class="lh78" span="6">
              <div class="customer-info">
                <div class="follow-time fs12 text-color">验证码</div>
                <div class="theCode title-text">{{customer.code}}</div>
              </div>
            </van-col>
            <van-col class="lh78 text-center text-color fs16" span="2" offset="1"><van-icon style="color:#8896a4;"  name="arrow"/></van-col>
          </van-row>
        </div>
      </van-list>
    </div>
    <div class="listTip">
      提示：“云账号呼叫转移设置”暂不支持小程序修改，请前往客户端-离线检测修改。
    </div>
    <van-loading class="loadingIcon" v-show="loading" type="spinner" color="#1fadf6">加载中...</van-loading>
    <filterComponent
      :options="toptions"
      @chooseComplete="chooseComplete"
      @resetOptions="resetOptions"
      @handleSelectOption="handleSelectOption"
      @filterShowFalse="onFilterCancel"
      :showFilter="showfilter"
    ></filterComponent>
  </div>
</template>

<script>
import Vue from "vue";
import filterComponent from "@/components/Filter.vue";
import config from "@/common/config";
import {
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  Icon,
  Search,
  List,
  Loading,
  Toast
} from "vant";
Vue.use(DropdownMenu)
  .use(DropdownItem)
  .use(Row)
  .use(Col)
  .use(Icon)
  .use(Search)
  .use(List)
  .use(Loading);
export default {
  name: "cloudHosting",
  components: {
    filterComponent
  },
  data() {
    return {
      showfilter: false,
      toptions: config.func.clone(config.pageConfig.customerFilterOptions),
      originOptions: config.func.clone(config.pageConfig.customerFilterOptions),
      filterParams: {
        type: 0,
        customerStatus: 0
      },
      page: 1,
      data: [],
      loading: false,
      finished: false,
      searchText: "",
      filterText: "全部",
      inputIsFocus: false,
      totalCount:'',
      isEmpty:false,
      tempOptions: config.func.clone(config.pageConfig.customerFilterOptions)
    };
  },
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    window.sessionStorage.setItem('toptions', JSON.stringify(this.toptions))
    if (to.path.indexOf('/cloudHosting') < 0) {
      window.sessionStorage.removeItem('toptions')
    }
    console.log('离开了:' + to.path)
    next()
  },
  watch: {
    showfilter (val) {
      if (!val) {
        this.toptions = config.func.clone(this.tempOptions)
      }
    }
  },
  methods: {
    init() {
      const reffilter = this.$route.params.reffilter;
      //已到期
      if(reffilter == "expire"){
        this.filterText = "代账客户,已到期";
        this.filterParams = {
          type: 0,
          customerStatus: 2
        };
        const newOptions = config.func.clone(this.toptions);
        newOptions.forEach(p => {
          if (p.value == 1) {
            p.children.forEach(o => {
              if (o.value == 1) {
                o.selected = true
              } else {
                o.selected = false
              }
            })
          }
          if(p.value == 2){
            p.children.forEach(o=>{
              if(o.value == 2){
                o.selected = true;
              }else{
                o.selected = false;
              }
              if (
                o.value == 1 ||
                o.value == 2 ||
                o.value == 4 ||
                o.value == 5 ||
                o.value == 6
              ) {
                o.show = true;
              }
            })
          }
        });
        this.toptions = newOptions;
      }
        //欠费
      if(reffilter == "arrearage"){
        this.filterText = "欠费";
        this.filterParams = {
          type: 0,
          customerStatus: 3
        };
        const newOptions = config.func.clone(this.toptions);
        newOptions.forEach(p => {
          if(p.value == 2){
            p.children.forEach(o=>{
              if(o.value == 3){
                o.selected = true;
              }else{
                o.selected = false;
              }
            })
          }
        });
        this.toptions = newOptions;
      }
        //代账客户
      if(reffilter == "agency"){
        this.filterText = "代账客户";
        this.filterParams = {
          type: 1,
          customerStatus: 0
        };
        const newOptions = config.func.clone(this.toptions);
        newOptions.forEach(p => {
          if(p.value == 1){
            p.children.forEach(o=>{
              if(o.value == 1){
                o.selected = true;
              }else{
                o.selected = false;
              }
            })
          }
        });
        this.toptions = newOptions;
      }
        //工商客户
      if(reffilter == "industry"){
        this.filterText = "工商客户";
        this.filterParams = {
          type: 2,
          customerStatus: 0,
          serviceStatus:0
        };
        const newOptions = config.func.clone(this.toptions);
        newOptions.forEach(p => {
          if(p.value == 1){
            p.children.forEach(o=>{
              if(o.value == 2){
                o.selected = true;
              }else{
                o.selected = false;
              }
            })
          }
          if(p.value == 3){
            p.show = true;
          }
        });
        this.toptions = newOptions;
      }
      this.getCloudHosting();
    },
    linkSkip(name, params, redType, rid) {
      if (rid) {
        this.$root.$emit("log-record", rid);
      }
      this.$router.push({
        name: name,
        query: params
      });
    },
    showFilter() {
      this.$root.$emit('log-record',"60010101");
      this.showfilter = !this.showfilter;
      if (this.showfilter) {
        this.tempOptions = config.func.clone(this.toptions)
      }
    },
    onFilterCancel() {
      this.showfilter = false;
    },
    //点击选中选项，对应处理
    handleSelectOption(ivalue, ovalue) {
      const newOptions = config.func.clone(this.toptions);
      //每次选中把其selected置为true,其余同类型的selected为false
      newOptions.forEach(p => {
        if (p.value == ivalue) {
          p.children.forEach(o => {
            if (o.value == ovalue) {
              o.selected = true;
            } else {
              o.selected = false;
            }
          });
        }
      });
      //点击客户类型-全部
      if (ivalue == 1 && ovalue == 0) {
        newOptions.forEach(p => {
          if (p.value == 2) {
            p.children.forEach(o => {
              if (o.value == 4 || o.value == 5 || o.value == 2 || o.value == 6) {
                o.show = false;
                o.selected = false;
              }
              // if (o.value == 1) {
              //   o.show = true;
              // }
            });
          }
          if (p.value == 3) {
            p.show = false;
            p.children.forEach(o => {
              if (o.value == 0) {
                o.selected = true;
              } else {
                o.selected = false;
              }
            });
          }
        });
      }
      //点击客户类型-代账客户
      if (ivalue == 1 && ovalue == 1) {
        newOptions.forEach(p => {
          if (p.value == 2) {
            p.show = true
            p.children.forEach(o => {
              if (
                o.value == 1 ||
                o.value == 2 ||
                o.value == 4 ||
                o.value == 5 ||
                o.value == 6
              ) {
                o.show = true;
              }
            });
          }
          if (p.value == 3) {
            p.show = false;
            p.children.forEach(o => {
              if (o.value == 0) {
                o.selected = true;
              } else {
                o.selected = false;
              }
            });
          }
        });
      }
      //点击客户类型-工商客户
      if (ivalue == 1 && ovalue == 2) {
        newOptions.forEach(p => {
          if (p.value == 2) {
            p.show = true
            p.children.forEach(o => {
              if (
                o.value == 1 ||
                o.value == 2 ||
                o.value == 4 ||
                o.value == 5 ||
                o.value == 6
              ) {
                o.show = false;
              }
              if (o.value == 0) {
                o.selected = true;
              } else {
                o.selected = false;
              }
            });
          }
          if (p.value == 3) {
            p.show = true;
          }
        });
      }
      this.toptions = newOptions;
    },
    getCloudHosting(phone) {
      this.loading = true;
      let url = ''
      if (phone) {
        url = this.$store.state.taxUrl + '/autotax/list/phone/code?page=' + this.page + "&limit=10&phone=" + phone + "&token=" + this.getcookie('gj-new');
      } else {
        url = this.$store.state.taxUrl + '/autotax/list/phone/code?page=' + this.page + "&limit=10&token=" + this.getcookie('gj-new');
      }
      this.$http
        .post(url, [])
        .then(res => {
          if (res.data.code == 200) {
            this.data = [...this.data, ...res.data.data];
            if(this.data.length == 0){
              this.isEmpty = true
            }else{
              this.isEmpty = false
            }
          } else {
            Toast(res.data.msg);
          }
          // 加载状态结束
          this.loading = false;
          if (res.data.data.length < 10) {
            this.finished = true;
          }
        })
        .catch(error => {
          console.log(error, "error");
          // 加载状态结束
          this.loading = false;
          this.finished = true;
        });
    }, 
    getcookie(sname){
      var acookie = document.cookie.split("; ");
      for (var i = 0; i < acookie.length; i++) {
        var arr = acookie[i].split("=");
        if (sname == arr[0]) {
          if (arr.length > 1)
            return arr[1]
          else
            return "";
        }
      }
      return "";
    },
    //点击选好了
    chooseComplete() {
      this.filterText = "";
      console.log(JSON.stringify(this.toptions), "chooseComplete");
      //遍历this.toptions对象获取selected为true的选项即为选择项
      this.toptions.forEach(p => {
        if (p.value == 1) {
          p.children.forEach(o => {
            if (o.selected == true) {
              this.filterParams.type = o.value;
              this.filterText += o.text + ",";
            }
          });
        }
        if (p.value == 2) {
          p.children.forEach(o => {
            if (o.selected == true) {
              this.filterParams.customerStatus = o.value;
              this.filterText += o.text + ",";
            }
          });
        }
        if (p.value == 3) {
          p.children.forEach(o => {
            if (o.selected == true) {
              this.filterParams.serviceStatus = o.value;
              this.filterText += o.text;
            }
          });
        }
      });
      this.page = 1;
      this.data = [];
      this.finished = false;
      this.getCloudHosting();
      this.tempOptions = config.func.clone(this.toptions);
      console.log(this.filterParams, "this.filterParams");
      this.showfilter = false;
    },
    //重置
    resetOptions() {
      console.log(JSON.stringify(this.toptions), "resetOptions");
      this.toptions = config.func.clone(this.originOptions);
      this.filterParams = {
        type: 0,
        customerStatus: 0
      };
      this.searchText = "";
      this.filterText = "全部";
      this.showfilter = false;
      this.page = 1;
      this.data = [];
      this.finished = false;
      this.getCloudHosting();
    },
    //滚动加载更多,页码加1
    onLoad() {
      this.page++;
      this.finished = false;
      this.getCloudHosting();
    },
    //搜索
    onSearch() {
      this.page = 1;
      this.data = [];
      this.finished = false;
      this.getCloudHosting();
      this.showfilter = false;
    },
    //点击搜索图标
    onSearchClick() {
      if (!this.inputIsFocus && this.searchText == "") {
        return false;
      }
      this.page = 1;
      this.data = [];
      this.finished = false;
      this.getCloudHosting(this.searchText);
      this.showfilter = false;
    },
    inputFocus() {
      this.$root.$emit('log-record',"60010102");
      this.inputIsFocus = true;
    },
    inputBlur() {
      this.inputIsFocus = false;
    },
    clearInput() {
      this.searchText = "";
      this.onSearch();
    },
    //按键盘enter或手机键盘搜索、前往
    enterPress(event) {
      if (event.keyCode == 13) {
        this.onSearch();
      }
    }
  },
  mounted: function() {
    this.$root.$emit('log-record',"60010100");
    //滚动条置顶
    document.documentElement.scrollTop = document.body.scrollTop = 0;
    if (window.sessionStorage.getItem('toptions')) {
      this.toptions = JSON.parse(window.sessionStorage.getItem('toptions'))
      this.chooseComplete()
    } else {
      this.init();
    }
  }
};
</script>

<style type="text/css" lang="stylus" scoped>
.cloudHosting {
  height: 100%;
  overflow: hidden;
  .listTip {
    padding: 0 0.12rem;
    position: absolute;
    bottom: 0.04rem;
    font-size: 0.12rem;
  }
}

.cloudHosting .filterBtn {
  background: #F9FBFC;
  color: #8896A4;
  width: 0.54rem;
  height: 0.3rem;
  line-height: 0.3rem;
  border: 1px solid #DAE5F1;
  border-radius: 100px;
  position: absolute;
  top: 0.12rem;
  right: 0.12rem;
  padding: 0 0.1rem;
}

.icon-select {
  font-size: 0.12rem;
  margin-left: 0.04rem;
}

.filterText {
  padding: 0.12rem;
}

.cloudHosting .pluss {
  width: 1.1rem;
  height: 1.1rem;
  border: 1px dashed #8896a4;
  line-height: 1.1rem;
  text-align: center;
  font-size: 0.24rem;
  color: #8896a4;
}

// 搜索框
.cloudHosting .searchwrap {
  padding: 0.12rem 0.14rem;
  width: 100%;
  line-height: 0.32rem;
  box-sizing: border-box;
  background: #ffffff;
  -padding-right: 0.94rem;
  margin-bottom: 0.12rem;
}

.searchwrap .inputwrap {
  position: relative;
}

.searchwrap .searchinput {
  width: 100%;
  padding: 0.08rem 0.25rem;
  height: 0.32rem;
  text-align: center;
  box-sizing: border-box;
  border-radius: 18px;
  border: 0;
  outline: none;
  border: 1px solid #E6EBF0;
  -webkit-appearance: none;
}

.searchwrap i {
  position: absolute;
  width: 30px;
  top: 0;
  line-height: 0.32rem;
  text-align: center;
  color: #bfcbd9;
  transition: all 0.3s;
}

.searchwrap .inputend-icon {
  right: 0px;
  font-size: 0.14rem;
}

.searchwrap .inputstart-icon {
  font-size: 0.14rem;
}

.searchwrap .lf90 {
  left: 1.22rem;
}

.searchwrap .lf5 {
  left: 0.01rem;
}

// 列表
.cloudHosting .list {
  padding: 0 0.12rem;
  height: calc(100% - 1.1rem);
  overflow-y: auto;
  .van-list{
    padding-bottom: 1.22rem;
  }
}

.cloudHosting .customer {
  height: 0.78rem;
  background: #ffffff;
  margin-bottom: 0.12rem;
  border-radius: 0.06rem;
}

.cloudHosting .customer-line {
  width: 100%;
  height: 0.78rem;
}

.lh78 {
  line-height: 0.78rem;
}

.cloudHosting .customer-info {
  padding: 0.17rem 0.15rem;
  height: 0.44rem;

  .customer-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 0.44rem;
    font-size: 0.16rem;
  }

  .follow-time {
    line-height: 0.2rem;
  }
  .theCloud {
    width: 0.2rem;
    height: 0.2rem;
    background-color: #409EFF;
    border-radius: 50%;
    display: none;
    color: #fff;
    line-height: 0.22rem;
    margin-left: 0.05rem;
    text-align: center;
    font-size: 0.12rem;
  }
  .theCloud.show{
    display: inline-block;
  }
  .theCloud.hide{
    display: none;
  }
  .theCode {
    line-height: 0.22rem;
  }
}

.empty {
  text-align: center;
  margin-top: 1.4rem;

  img {
    width: 0.8rem;
  }

  .desc {
    margin-top: 0.08rem;
    color: #B4BEC7;
    font-size: 0.12rem;
  }
}

.loadingIcon {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .van-loading__text {
    color: #1fadf6;
  }
}
</style>
